import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationsService } from 'web-common/src/app/notifications.service';
import { AdminUsersService } from '../admin-users/admin-users.service';

@Injectable({ providedIn: 'root' })
export class CsvExportService {
  private spinnerSubject = new Subject<boolean>();
  public spinner$ = this.spinnerSubject.asObservable();

  constructor(
    private adminUserService: AdminUsersService,
    private notifications: NotificationsService
  ) {}

  public downloadCSVFile(
    mode: 'users' | 'invited',
    params: any
  ): void {
    this.spinnerSubject.next(true);

    const handleError = (error: any) => {
      console.error('Error downloading the file: ', error);
      this.notifications.error('Error downloading the file');
      this.spinnerSubject.next(false);
    };

    const downloadFileCallback = (data: any) => {
      if (!data) {
        this.notifications.info('Your report will be sent by email.');
      } else {
        this.downloadFile(data, mode);
      }
      this.spinnerSubject.next(false);
    };

    if (mode === 'invited') {
      const { page, pageSize, email } = params;
      this.adminUserService
        .exportInvited(page, pageSize, email)
        .subscribe(downloadFileCallback, handleError);
    } else {
      this.adminUserService
        .exportUsers(
          params.currentPage,
          params.email,
          params.pageSize,
          params.showDisabled,
          params.lastActive,
          params.disabledChecked,
          params.enabledChecked,
          params.adminOnly,
          params.roleFilters,
          params.areaFilters,
          params.additionalFilters,
          params.sortField,
          params.sortType,
          params.byAdminsEmail
        )
        .subscribe(downloadFileCallback, handleError);
    }
  }

  private downloadFile(data: any, mode: string) {
    const bom = '\ufeff';
    const blob = new Blob([bom + data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const fileName = this.getFileName(mode);

    if ((window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveBlob(blob, fileName);
    } else {
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }

    window.URL.revokeObjectURL(url);
  }

  private getFileName(mode: string): string {
    const date = new Date().toISOString().split('T')[0];
    const prefix = mode === 'invited' ? 'Invites' : 'Users';
    return `${prefix}-${date}.csv`;
  }
}
